import { Route, Navigate } from "react-router";
import { ScoreDetail } from "src/components/ScoreDetail/ScoreDetail";
import { DimensionTreeSwitch } from "src/components/ScoreDetail/Dimensions/DimensionTreeSwitch";
import { useProductRouter } from "../Product/productRouter";
import { useIntermediateProductRouter } from "../Product/intermediateProductRouter";
import { QuestionnaireUpdate } from "./Questionnaire/QuestionnaireUpdate";
import { useTrajectoryCompanyRouter } from "./Trajectory/TrajectoryRouter";
import { Questionnaire } from "./Questionnaire/Questionnaire";
import { MyCompany } from "./MyCompany/MyCompany";
import { useIngredientRouter } from "../Ingredient/ingredientRouter";
import { useSupplierRouter } from "../Supplier/supplierRouter";
import { usePackagingRouter } from "../Packaging/packagingRouter";
import { useTransportRouter } from "../Transport/transportRouter";
import { useTransformationRouter } from "../Transformation/transformationRouter";
import { useDistributionRouter } from "../Distribution/distributionRouter";
import { companySlug } from "src/services/URLHandler";
import { LegalRequirements } from "./LegalRequirements/LegalRequirements";
import {
    CompanyMetadataContext,
    CompanyOneOverviewLayout,
    CompanyOverviewContext,
    CompanyOverviewLayout,
    CompanyQuestionnaireLayout,
    CompanyScoreDetailContext,
    CompanyScoresContext,
    RedirectInsideScores,
    RedirectToHeadings,
    RedirectToOverview,
} from "./companyRouter.components";

export const useCompanyRouter = () => {
    const productRouter = useProductRouter();
    const intermediateProductRouter = useIntermediateProductRouter();
    const ingredientRouter = useIngredientRouter();
    const packagingRouter = usePackagingRouter();
    const supplierRouter = useSupplierRouter();
    const transportRouter = useTransportRouter();
    const transformationRouter = useTransformationRouter();
    const distributionRouter = useDistributionRouter();
    const trajectoryCompanyRouter = useTrajectoryCompanyRouter();

    return (
        <Route path={`${companySlug}/:companyId`} element={<CompanyMetadataContext />}>
            <Route index element={<Navigate to="scores" replace />} />

            {productRouter}
            {intermediateProductRouter}
            {ingredientRouter}
            {packagingRouter}
            {supplierRouter}
            {transportRouter}
            {transformationRouter}
            {distributionRouter}

            <Route element={<CompanyScoresContext />}>
                <Route path="overview" element={<CompanyOverviewContext />}>
                    <Route element={<CompanyOverviewLayout />}>
                        <Route index element={<MyCompany />} />
                    </Route>
                    <Route path=":ssqId" element={<CompanyOneOverviewLayout />}>
                        <Route index element={<MyCompany />} />
                    </Route>
                </Route>

                {/* Redirect previous `/scores` -> `/overview` */}
                <Route path="scores" element={<RedirectToOverview />} />

                <Route path="ssq/:ssqId">
                    {trajectoryCompanyRouter}
                    <Route path="campaign/:campaignId">
                        <Route path="scores/:scoreId">
                            <Route index element={<RedirectInsideScores />} />

                            <Route path="questionnaire">
                                <Route element={<CompanyQuestionnaireLayout />}>
                                    <Route index element={<Questionnaire />} />
                                </Route>

                                {/* It will redirect all `edit` parts to `headings` :) */}
                                <Route path="edit/:headingId" element={<RedirectToHeadings />} />
                                <Route path="headings/:headingId">
                                    <Route index element={<QuestionnaireUpdate />} />
                                </Route>
                            </Route>

                            <Route element={<CompanyQuestionnaireLayout />}>
                                {/* Normal Score */}
                                <Route element={<CompanyScoreDetailContext />}>
                                    <Route path="distribution" element={<ScoreDetail selectedTab={"distribution"} />}>
                                        <Route index element={<DimensionTreeSwitch mode={"distribution"} />} />
                                    </Route>
                                    <Route path="comparison" element={<ScoreDetail selectedTab={"comparison"} />}>
                                        <Route index element={<DimensionTreeSwitch mode={"comparison"} />} />
                                    </Route>
                                    <Route path="evolution" element={<ScoreDetail selectedTab={"evolution"} />}>
                                        <Route index element={<DimensionTreeSwitch mode={"evolution"} />} />
                                    </Route>
                                </Route>
                                <Route path="regulatory">
                                    <Route index element={<LegalRequirements />} />
                                </Route>
                            </Route>
                        </Route>
                    </Route>
                </Route>
            </Route>
        </Route>
    );
};
